"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./NotificationBanner.less");

var _close = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/close-2"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var NotificationBanner = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(NotificationBanner, _Component);

  var _super = _createSuper(NotificationBanner);

  function NotificationBanner(props) {
    var _this;

    (0, _classCallCheck2.default)(this, NotificationBanner);
    _this = _super.call(this, props);
    _this.state = {
      hidden: false
    };
    return _this;
  }

  (0, _createClass2.default)(NotificationBanner, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          icon = _this$props.icon,
          closeButton = _this$props.closeButton;
      var hidden = this.state.hidden;

      if (!hidden) {
        var closeText = this.getDefaultCloseText();

        if (typeof closeButton !== 'boolean') {
          closeText = closeButton;
        }

        return /*#__PURE__*/_react.default.createElement("div", {
          className: "ui-notification-banner ".concat(this.props.className),
          role: "alert",
          "aria-live": this.props.ariaLive
        }, icon ? /*#__PURE__*/_react.default.createElement("span", {
          className: "ui-banner-icon"
        }, this.props.icon) : null, /*#__PURE__*/_react.default.createElement("span", {
          className: "ui-text"
        }, this.props.children), closeButton ? /*#__PURE__*/_react.default.createElement("span", {
          className: "ui-close",
          onClick: function onClick() {
            _this2.onClose();
          },
          "aria-hidden": "true"
        }, closeText) : null);
      } else {
        return null;
      }
    }
  }, {
    key: "onClose",
    value: function onClose(e) {
      this.setState({
        hidden: true
      });

      if (this.props.onClose) {
        this.props.onClose(e);
      }
    }
  }, {
    key: "getDefaultCloseText",
    value: function getDefaultCloseText() {
      return /*#__PURE__*/_react.default.createElement(_close.default, null);
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        className: _propTypes.default.string,
        icon: _propTypes.default.any,
        closeButton: _propTypes.default.any,
        hidden: _propTypes.default.bool,
        ariaLive: _propTypes.default.oneOf(['assertive', 'polite', 'off'])
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        ariaLive: 'polite'
      };
    }
  }]);
  return NotificationBanner;
}(_react.Component);

exports.default = NotificationBanner;